module.exports = __webpack_public_path__ + "static/img/5.9170559.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/2/sp/5.png
// module id = Jb43
// module chunks = 0